import { useTranslation } from 'react-i18next'
import DefaultLayout from '../components/layouts/DefaultLayout'
import {
  Box,
  Button,
  Input,
  Stack,
  Text,
  VStack,
  useToast
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { authState } from '../atoms/auth'
import { useRecoilState } from 'recoil'
import { useState } from 'react'
import { signIn } from '../services/apiService'

const SignIn = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [auth, setAuth] = useRecoilState(authState)
  const toast = useToast()

  // 입력값 상태
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = async () => {
    try {
      const { data: res } = await signIn({
        account,
        password
      })
      if (res.statusCode === 200) {
        navigate('/')
        setAuth({
          ...res.data
        })
      }
    } catch (err: any) {
      toast({
        title: t('로그인'),
        description:
          err.response?.data?.message || t('알 수 없는 오류가 발생했습니다.'),
        status: 'error',
        duration: 3000,
        isClosable: true
      })
    }
  }

  return (
    <DefaultLayout>
      <Box
        minH="80vh"
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        pt={'60px'}
        bg="dark.bg"
      >
        <VStack spacing={8} w="full" maxW="md" px={6} textAlign="center">
          {/* 타이틀 */}
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              {t('로그인')}
            </Text>
            <Text fontSize="sm" color="gray.400" mt={2}>
              {t('자동매매의 시작, WinningBot에 오신 것을 환영합니다!')}
              <br />
              {t('먼저 서비스 이용을 위해 로그인 해주세요')}
            </Text>
          </Box>

          {/* 입력폼 */}
          <Stack spacing={4} w="full">
            <Input
              placeholder={t('아이디')}
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              size="lg"
            />
            <Input
              placeholder={t('비밀번호')}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin()
                }
              }}
              size="lg"
            />

            <Button bg="brand.500" color="#1a1a1a" _hover={{ bg: 'brand.400' }} size="lg" onClick={handleLogin}>
              {t('로그인')}
            </Button>
            <Button
              variant="link"
              colorScheme="gray"
              onClick={() => navigate('/signUp')}
            >
              {t('회원가입')}
            </Button>
          </Stack>
        </VStack>
      </Box>
    </DefaultLayout>
  )
}

export default SignIn
